import * as constants from './constants'

export const user = (state = null, action) => {
    switch (action.type) {
        case constants.SET_AUTHENTICATED_USER:
        case constants.SET_TOKEN:
            return action.result || null
        case constants.LOGOUT:
            return null
        default:
            return state
    }
}

export const latestConfirmedReservation = (state = null, action) => {
    switch (action.type) {
        case constants.SET_LATEST_CONFIRMED_WAITING_LIST:
            return action.result
        case constants.LOGOUT:
            return null
        default:
            return state
    }
}
